const state = {
  selectedUsers: []
}

const mutations = {
  updateSelectedUsers (state, selection) {
    state.selectedUsers = selection
  }
}

const getters = {
  selectedUsers: state => {
    return state.selectedUsers
  }
}

export default {
  state,
  mutations,
  getters
}
